import React from "react";
import CustomersStore from "../customersStore";
import { ClienteDto } from "../../generated";
import { MapLink } from "../../common/components/MapLink";
import { Loading } from "../../common/components/loading";
import { PhoneComponents } from "../../common/components/PhoneComponent";

interface Props {
    id: number
}

const CustomerMapLink = (props: { customer: ClienteDto, text?: string }) => <MapLink
    query={(props.customer.latitudine && props.customer.longitudine)
        ? { lat: +props.customer.latitudine, lng: +props.customer.longitudine }
        : props.customer.indirizzo && props.customer.comune && `${props.customer.indirizzo},${props.customer.comune.nomeComune}`
    }
    text={props.text} />

export const CustomerCardSmall = (props: Props) => {

    const { id } = props;

    const customer = CustomersStore.use(id)
    if (!customer)
        return <Loading />

    return (
        <div className="row">
            <p className="col"><strong>Indirizzo: </strong>
                <CustomerMapLink customer={customer} text={customer.indirizzo} /><br />
                {customer.cap ?? customer.comune?.cap} {customer.comune?.nomeComune} ({customer.comune?.provincia})<br />
                {customer.frazione?.nomeFrazione?.toLowerCase() !== customer.comune?.nomeComune?.toLowerCase() && <>{customer.frazione?.nomeFrazione}<br /></>}
                <strong>Piano: </strong>{customer.piano}
            </p>
            <div className="w-100" />
            <p className="col"><strong>Codice Fiscale: </strong>{customer.codiceFiscale}</p>
            <p className="col"><strong>Partita IVA: </strong>{customer.partitaIva}</p>
            <div className="w-100" />
            <p className="col"><strong>Cellulare: </strong>{customer.cell && <PhoneComponents tel={customer.cell} showWhatsApp />}</p>
            <p className="col"><strong>Telefono: </strong>{customer.telefono && <PhoneComponents tel={customer.telefono} />}</p>
            <p className="col"><strong>Fax: </strong>{customer.fax}</p>
            <p className="col"><strong>Email: </strong>{customer.email}</p>
        </div>
    );
}
